<i
    (click)="onClickOrderButton()"
    [ngClass]="{
        'fa-sort-up': orderBy === 'ascending',
        'fa-sort-down': orderBy === 'descending',
        'fa-sort': !orderBy,
    }"
    class="fa fa-sort cursor-pointer"
></i>
